/* eslint-disable no-console */
import React from 'react';
import styled from 'styled-components';
import { SuperAdminLayout } from 'Components/Layout/SuperAdminLayout';
import Component from 'Components/SuperAdminPage/SuperAdminMessages';

const ContentContainer = styled.div`
  width: 100%;
  margin: 20px;
  overflow: auto;
  flex: 1;
`;

const SuperAdminMessages = () => {
  return (
    <SuperAdminLayout>
      <ContentContainer>
        <Component />
      </ContentContainer>
    </SuperAdminLayout>
  );
};
export default SuperAdminMessages;
